import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManageProductsCreate } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function ManageProductsCreatePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('manage-products-create-component.metatags.title'),
        description: t('manage-products-create-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myProductsCreate,
        index: false,
    });

    return <ManageProductsCreate />;
}
